module.exports = __webpack_public_path__ + "static/media/hi-1.29012dd8.mp3";